module.exports = __webpack_public_path__ + "static/media/Slide5.af0ad6e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jp/Slide5.png
// module id = 636
// module chunks = 0